import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jctj",
  "use": "icon-jctj-usage",
  "viewBox": "0 0 825.37 859.8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 825.37 859.8\" id=\"icon-jctj\"><title>进尺统计</title><path d=\"M253.53,237.25H803.75v68.81H253.53ZM528.84,512.46V443.82H253.53v68.67ZM253.53,649.85H735v68.67H253.53Z\" transform=\"translate(-115.94 -99.76)\" /><path d=\"M115.94,99.76l0,824.79H941.31V855.88H184.75V99.76\" transform=\"translate(-115.94 -99.76)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol